module.exports = __webpack_public_path__ + "static/media/clear.673767b2.svg";